import axios from 'axios'
import utf8 from 'utf8/utf8'
import router from '../router'

// const baseUrl = 'http://localhost:8080'
const baseUrl = 'https://dev.pollide.co.kr'

// axios 인스턴스를 생성
const instance = axios.create({
  baseURL: baseUrl,
  // timeout: 1000000
  timeout: 3000
})

const accessTokenUserName = 'pollide'
const accessTokenPassword = '7ghj90iokmnbgs2bm9iokmhbvcv'
const signUpTokenUserName = 'pollide-trust'
const signUpTokenPassword = 'vkmnvcf89oknbv6cxd4tghjsxdfcs'

instance.interceptors.request.use(
  function (config) {
    // 요청 성공 직전 호출.
    // axios 설정값 작성
    if(config.url === '/api/oauth/token') {
      // 토큰생성 api
      let usernameAndPassword = ''
      if(config.tokenType === 'signUpToken') {
        // 회원가입 토큰일 경우
        usernameAndPassword = signUpTokenUserName + ':' + signUpTokenPassword
        let bytes = utf8.encode(usernameAndPassword)
        let base64 = btoa(bytes)
        config.headers = {
          'Content-Type': 'multipart/form-data',
          Authorization: 'Basic ' + base64
        }
      }else{
        // access 토큰일 경우
        usernameAndPassword = accessTokenUserName + ':' + accessTokenPassword
        let bytes = utf8.encode(usernameAndPassword)
        let base64 = btoa(bytes)
        config.headers = {
          Authorization: 'Basic ' + base64
        }
      }
    }else if(config.url === '/api/ad/user/create') {
      // 회원 가입 api
      config.headers = {
        Authorization: 'Bearer ' + config.signUpToken
      }
    }else if(config.type === 'blob') {
      // img를 blob으로 넘길 경우
      config.headers = {
        Authorization: 'Bearer ' + window.store.getters.getAccessToken,
        'Content-Type': 'multipart/form-data'
      }
    }else if(config.type === 'public') {
      // 공용
      // 헤더추가 없음
    }else{
      // 그외 일반적인 api들
      config.headers = {
        Authorization: 'Bearer ' + window.store.getters.getAccessToken
      }
    }
    return config
  },
  function (error) {
    // 요청 에러 직전 호출.
    return Promise.reject(error)
  }
)

/*
    2. 응답 인터셉터 / 2개의 콜백 함수.
*/
instance.interceptors.response.use(
  function (response) {
    // http status가 200인 경우 응답 성공 직전 호출. .then() 으로 이어짐
    return response
  },
  function (error) {
    // http status가 200이 아닌 경우 응답 에러 직전 호출. 각 요청의 .catch()로 이어짐
    // 토큰 만료 // 비정상 접근 인터셉터
    let originalRequest = error.config
    if (error.response.status === 401 && error.response.data.error === 'invalid_token') {
      if(window.store.getters.getRefreshToken == null || window.store.getters.getRefreshToken === '') {
        // 비정상적인 접근
        alert('비 정상적인 경로로 진입하여 로그인 페이지로 이동합니다.')
        router.push({name: 'signIn'})
        localStorage.removeItem('vuex')
        return Promise.reject(error)
      }else {
        // 토큰 만료
        let form = new FormData()
        form.append('refresh_token', window.store.getters.getRefreshToken)
        form.append('grant_type', 'refresh_token')
        form.append('scope', 'read write')

        let bytes = utf8.encode('pollide:7ghj90iokmnbgs2bm9iokmhbvcv')
        let base64 = btoa(bytes)
        let customHeaders = {
          Authorization: 'Basic ' + base64
        }
        return axios.post(baseUrl + '/api/oauth/token', form, {headers: customHeaders}).then((data) => {
          window.store.commit('setAccessTokenValue', {accessToken: data.data.access_token})
          window.store.commit('setRefreshTokenValue', {refreshToken: data.data.refresh_token})
          originalRequest.headers['Authorization'] = 'Bearer ' + window.store.getters.getAccessToken // new header new token
          return axios(originalRequest)
        }).catch(error => {
          if (error.response.status === 400 && error.response.data.error === 'invalid_grant') {
            // refresh 토큰도 시간만료
            // 로그인 페이지로 이동
            alert('장시간 조작하지 않아 로그아웃 후 로그인 페이지로 이동합니다.')
            router.push({name: 'signIn'})
            localStorage.removeItem('vuex')
          }
        })
      }
    }else {
      return Promise.reject(error)
    }
  }
)

export default instance



// WEBPACK FOOTER //
// ./src/axiosApis/axiosUtils.js